module.exports = __webpack_public_path__ + "img/parc1.e3872c81.png";